/* fenlo-pdp-cart.js — the three things the static page could not do.
   Loaded BEFORE fenlo-pdp.js so its listeners exist before the engine boots.

   1. Add to cart. The engine renders `<button type="button">Add to cart</button>`
      with no form around it, in two places (the buy box and the sticky bar).
      One delegated listener covers both and every future re-render, which a
      per-node listener would not -- ctaMarkup() replaces that node on every
      state change.
   2. The restock form. Moved, never cloned: cloning would reset a half-typed
      email address on every swatch click, and would also duplicate the form's
      CAPTCHA token.
   3. Nothing else. No analytics, no third-party host. */
(function () {
  "use strict";
  window.FENLO_LIQUID_RESTOCK = true;

  var MAP = window.FENLO_V || {};          /* stripped sku -> variant id */
  function stripCode(s) { return String(s || '').replace(/-FBA2?(?=(-|$))/g, ''); }

  function current(art) {
    var pk = art.getAttribute('data-p');
    var d = window.D && window.D[pk];
    if (!d) return null;
    var sw = art.querySelector('.sw.sel, .sw[aria-checked="true"], .sw[aria-pressed="true"]');
    var name = sw ? (sw.getAttribute('data-v') || sw.textContent.trim()) : d.defaultV;
    var v = d.variants[name] || d.variants[d.defaultV];
    return v ? { pk: pk, name: name, v: v } : null;
  }

  function qty(art) {
    var q = art.querySelector('.qty input[type="number"], .qty input');
    var n = q ? parseInt(q.value, 10) : 1;
    return (n > 0 && n < 1000) ? n : 1;
  }

  /* ---- add to cart / buy now --------------------------------------------
     Same POST, different destination: Add to cart lands on /cart, Buy now goes
     straight to /checkout. One handler so the two can never drift apart, and
     delegated so it also covers the sticky bar's copies, which are created and
     destroyed as the variant changes. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button.btn');
    if (!btn) return;
    var txt = btn.textContent || '';
    var now = /buy now/i.test(txt);
    if (!now && !/add to cart/i.test(txt)) return;

    var art = btn.closest('article.product');
    if (!art) {                       /* the sticky bar lives outside <article> */
      /* by [data-p], NOT getElementById: pk is the product HANDLE and the
         article carries it as a data attribute, not as an id. Looking it up by
         id returned null, and the null then short-circuited the whole handler —
         the sticky bar's button would have silently done nothing. */
      var pk = window.__fenloActive;
      art = (pk && document.querySelector('article.product[data-p="' + pk + '"]'))
            || document.querySelector('article.product');
    }
    if (!art) return;

    var cur = current(art);
    if (!cur) return;
    var id = MAP[stripCode(cur.v.sku)];
    if (!id) return;                  /* unmapped sku: let it do nothing rather
                                         than send the shopper to a 404 cart */
    e.preventDefault();
    var dest = now ? '/checkout' : '/cart';
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = now ? 'Starting…' : 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty(art) }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      window.location.href = dest;
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = label;
      /* No silent failure: the shopper still gets a working route to checkout.
         The fallback is /cart even for Buy now — sending someone to /checkout
         when the add may not have landed is how you get an empty checkout. */
      window.location.href = '/cart';
    });
  }, true);

  /* ---- restock form relocation ------------------------------------------ */
  function park() { return document.getElementById('fenlo-rs-park'); }

  function placeRestock() {
    var form = document.querySelector('#fenlo-rs-park [data-restock], article.product [data-restock]');
    if (!form) return;
    var art = document.querySelector('article.product');
    if (!art) return;
    var ctas = document.getElementById(art.getAttribute('data-p') + '-ctas');
    if (!ctas) return;

    if (ctas.dataset.cta === 'none') {
      if (form.parentNode !== ctas) ctas.appendChild(form);
      form.hidden = false;
    } else if (park() && form.parentNode !== park()) {
      park().appendChild(form);
    }
  }

  function syncRestockFields(detail) {
    var form = document.querySelector('[data-restock]');
    if (!form || !detail) return;
    var d = window.D && window.D[detail.pk];
    var v = d && d.variants[detail.name];
    var sku = stripCode(v && v.sku);
    var set = function (k, val) {
      var f = form.querySelector('[data-rs-field="' + k + '"]');
      if (f) f.value = val;
    };
    set('sku', sku);
    set('variant_id', MAP[sku] || '');
    set('variant', detail.name);
    form.setAttribute('data-rs-sku', sku);
    var label = form.querySelector('.rs-v');
    if (label) label.textContent = detail.name;
  }

  window.addEventListener('fenlo:variant', function (e) {
    syncRestockFields(e.detail);
    placeRestock();
  });
  document.addEventListener('DOMContentLoaded', placeRestock);
  window.addEventListener('load', placeRestock);
})();
